import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import AngelaIconMultiR1C from "../Common/Angela/AngelaIconMultiR1C";
import AngelaIcon1R from "../Common/Angela/AngelaIcon1R";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenClusterColVer from "../Common/Graph/ZenClusterColVer";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class SnippetLinePerformanceMain extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    Temp1: null,
    LineOAPQ_Performance: null,
    dict_0008: null,
    dict_0009: null,
    dict_0010: null,
    dict_0011: null,
    dict_0012: null,
    dict_0013: null,
    LineDashMatrixCol2: null,
    OeeTrend: null,
    ShiftWiseTrend: null,
    HourlyTrend: null,
    dataLoading: false,
    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Houdini Test Header");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab = "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "Snippet1LineOee",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["Temp1"] = resp["data"]["Temp1"];
        respData["LineOAPQ_Performance"] = resp["data"]["LineOAPQ_Performance"];
        respData["dict_0008"] = resp["data"]["dict_0008"];
        respData["dict_0009"] = resp["data"]["dict_0009"];
        respData["dict_0010"] = resp["data"]["dict_0010"];
        respData["dict_0011"] = resp["data"]["dict_0011"];
        respData["dict_0012"] = resp["data"]["dict_0012"];
        respData["dict_0013"] = resp["data"]["dict_0013"];
        respData["LineDashMatrixCol2"] = resp["data"]["LineDashMatrixCol2"];
        respData["OeeTrend"] = resp["data"]["OeeTrend"];
        respData["ShiftWiseTrend"] = resp["data"]["ShiftWiseTrend"];
        respData["HourlyTrend"] = resp["data"]["HourlyTrend"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        Testr Arsenal
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                      {/* _______Row No 1________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "30%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIconMultiR1C
                              divId={"Temp1"}
                              data={this.state.Temp1.data}
                              config={this.state.Temp1.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "30%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIconMultiR1C
                              divId={"LineOAPQ_Performance"}
                              data={this.state.LineOAPQ_Performance.data}
                              config={this.state.LineOAPQ_Performance.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"LineDashMatrixCol2"}
                              data={this.state.LineDashMatrixCol2.data}
                              config={this.state.LineDashMatrixCol2.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 2________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "50%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"OeeTrend"}
                              data={this.state.OeeTrend.data}
                              config={this.state.OeeTrend.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenClusterColVer
                              divId={"ShiftWiseTrend"}
                              data={this.state.ShiftWiseTrend.data}
                              config={this.state.ShiftWiseTrend.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"HourlyTrend"}
                              data={this.state.HourlyTrend.data}
                              config={this.state.HourlyTrend.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 3________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "0px 10px 0px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0008"}
                              data={this.state.dict_0008.data}
                              config={this.state.dict_0008.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 4________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "0px 10px 0px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0009"}
                              data={this.state.dict_0009.data}
                              config={this.state.dict_0009.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 5________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0010"}
                              data={this.state.dict_0010.data}
                              config={this.state.dict_0010.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 6________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0011"}
                              data={this.state.dict_0011.data}
                              config={this.state.dict_0011.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 7________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0012"}
                              data={this.state.dict_0012.data}
                              config={this.state.dict_0012.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 8________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"dict_0013"}
                              data={this.state.dict_0013.data}
                              config={this.state.dict_0013.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default SnippetLinePerformanceMain;
